<template>
  <CModal v-if="show && entity"
          :title="getModalTitle"
          color="danger"
          :show="show"
          :centered="true"
          @update:show="$emit('update:show', false)">

    <div class="content">
      <div class="modal-title">
        <h5>Are you sure to remove the following item?</h5>
        <i v-if="loading" class="fa fa-cog fa-spin fa-2x"></i>
      </div>

      <div class="details-row">
        <div class="details-row__title">Id</div>
        <div class="details-row__value">{{ entity.berthId }}</div>
      </div>
      <div class="details-row">
        <div class="details-row__title">Name</div>
        <div class="details-row__value">{{ entity.berthName }}</div>
      </div>
    </div>

    <template #footer>
      <CButton @click="$emit('update:show', false)" color="secondary">
        Cancel
      </CButton>
      <CButton @click="handleRemoveEntity" color="danger">
        Remove
      </CButton>
    </template>

  </CModal>
</template>

<script>
import { mapActions } from 'vuex'
import startCase from 'lodash-es/startCase'


export default {
  name: 'remove-entity-modal',

  components: {},

  props: {
    entity: {
      type: Object,
      default: null,
    },
    entityType: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      errors: [],
      loading: false,
    };
  },

  methods: {
    ...mapActions(
      'polygons', [
        'deleteBerth',
      ],
    ),

    async handleRemoveEntity() {
      this.loading = true;
      const apiMethod = this.getAPIMethod();
      let result = await apiMethod(this.entity);

      if(result.error) {
        this.errors.push('Unknown error');
      } else {
        this.$emit('updated', this.entityType);
        this.$emit('update:show', false);
      }

      this.loading = false;
    },

    getAPIMethod() {
      const methodName = `delete${startCase(this.entityType)}`;
      if(this[methodName]) {
        return this[methodName];
      } else {
        console.error(`Method ${methodName} isn't allowed!`);
        return null;
      }
    },
  },

  computed: {
    getModalTitle() {
      return `Are you sure you want to delete the ${this.entityType}?`;
    },
  },
}
</script>

<style scoped>

</style>

<style scoped lang="scss">
  .details-row {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dotted #ad0000;

    &__title {
      min-width: 50px;
      padding-right: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__value {
      padding-left: 10px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      direction: rtl;
      text-align: left;
    }
  }

  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    .fa-cog {
      color: #adadad;
    }
  }
</style>
